function widgetTranslation() {
    // Language Widget Blocks

    var widget = '.js-widget-translation';
    var toggler = '.js-widget-translation-toggler';
    var headerBtn = '.js-widget-translation-header';

    $(toggler).on('click', function () {
        var widget_obj = $(this).closest(widget);

        if (widget_obj.hasClass('active')) {
            widget_obj.removeClass('active');
        } else {
            widget_obj.addClass('active');
        }
    });

    $(headerBtn).on('click', function (e) {
        e.preventDefault();
        $(toggler).trigger('click');
    });

    $(document).on('click', function (e) {
        if (
            !$(e.target).closest(widget).length &&
            $(widget).hasClass('active') &&
            !$(e.target).closest(headerBtn).length
        ) {
            $(widget).removeClass('active');
        }
    });

    const languageSwitchersBlocks = document.querySelectorAll(
        `.js-google-translate-switcher`,
    );

    if (languageSwitchersBlocks.length) {
        // Looping through all of them (we can have several of them)
        [...languageSwitchersBlocks].map((languageSwitcherBlock) => {
            // Adding click listeners
            languageSwitcherBlock.addEventListener('click', (event) => {
                // Click Target
                const target = event.target;
                // Language switcher
                const button = target.closest('a');
                // If we click out of button - do nothing
                if (!button) {
                    return;
                }

                // Preventing default behaviour
                event.preventDefault();

                // Language value of this button
                const chosenLanguage = button.getAttribute('data-href');
                if (!chosenLanguage) {
                    return;
                }

                // Google Translate Select
                const googleTranslateSelect =
                    document.querySelector('.goog-te-combo');
                if (!googleTranslateSelect) {
                    return;
                }

                // Set the chosen value
                googleTranslateSelect.value = chosenLanguage;
                // Dispatching event and allow google to translate the page
                googleTranslateSelect.dispatchEvent(new Event('change'));
            });
        });
    }
}

export default widgetTranslation;
